<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <!-- Popup header -->
        <v-toolbar color="elevation-0">
          <v-toolbar-title>
            <h3 id="myModalLabel">{{title}}</h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon data-dismiss="modal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Popup content -->
        <v-container container--fluid>
          <v-layout wrap>
            <v-flex xs12 md12>
              <div v-if="posts.length === 0">
                <p class="no-posts">Post is private or deleted</p>
              </div>
              <v-card class="mb-2" v-for="post in posts" :key="post">
                <div v-html="post.oembed" v-if="!platform || platform === 'instagram'"></div>
                <div v-if="platform === 'tiktok'">
                  <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                    <iframe :src="post" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                  </div>
                </div>
                <div style="max-width:300px;max-height:500px;" v-if="platform === 'youtube'">
                  <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 100%; padding-top: 90px;">
                    <iframe :src="post" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analysisAPI from '../ContentAnalysis/contentAnalysisAPI';
export default {
  name: 'InfluencerPostModal',
  props: ['modalId', 'title', 'shortCodes', 'platform'],
  data() {
    return {
      posts: []
    };
  },
  watch: {
    shortCodes(newValue) {
      this.shortCodes = newValue;
      if (!this.platform || this.platform === 'instagram') {
        this.posts = [];
        this.retrivePost();
      } else {
        this.posts = Object.assign([], this.shortCodes)
      }
    }
  },
  methods: {
    retrivePost() {
      this.shortCodes.forEach(async code => {
        let resp = await analysisAPI.oembed(code);
        if (resp.oembed.length > 0) {
          this.posts.push(resp);
        }
        setTimeout(() => {
          window.instgrm.Embeds.process();
        }, 100);
      });
    }
  }
};
</script>

<style>
.filter {
  padding: 5px;
  width: 180px;
  border: 1px solid gray;
  border-radius: 6px;
  margin-bottom: 10px;
}
.no-posts {
    text-align: center;
    font-size: 20px;
    color: rgba(0,0,0,.38);
}
</style>



// WEBPACK FOOTER //
// InfluencerPostsModal.vue?2f601951